import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { contentPadding } from '../../../theme/mixins';
import { smallSpacedHeading } from '../../../theme/typography';
import { Icon } from '../icon';
import { themeColor, themeSize, themeZIndex } from '../../../theme/getters';
import { slideFromDownTransition } from '../../../theme/transitions';
import { media } from '../../../theme/media';

export const Container = styled.section`
  width: 100%;
  min-height: 100vh;
  background-color: ${themeColor('secondaryBlue')};
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  top: 0;
  width: 100%;
  ${contentPadding};
  position: fixed;
  height: ${themeSize('header')}px;
  align-items: center;
  display: grid;

  grid-template-columns: 32px 1fr 32px;
  ${media.tabletPortrait`
    grid-template-columns: 100px 1fr 100px;
  `};

  grid-template-areas: 'left-icon title right-icon';
  background-color: ${themeColor('white')};
  border-bottom: 1px solid ${themeColor('border')};
  z-index: ${themeZIndex('overlayHeader')};
  text-align: center;
  ${slideFromDownTransition};
`;

export const StepDisplay = styled.div`
  display: flex;
  align-items: center;
  grid-area: left-icon;
`;

export const StepInfo = styled.div`
  display: none;
  ${media.tabletPortrait`
    display: block;  
  `};
`;

export const Title = styled.h1`
  ${smallSpacedHeading};
  grid-area: title;
`;

export const BackIcon = styled(Icon).attrs(() => ({ size: 32 }))`
  cursor: pointer;

  ${props =>
    props.inactive &&
    css`
      pointer-events: none;
    `}
  ${media.tabletPortrait`
    margin-right: 16px;
  `};
`;

export const CloseIcon = styled(Link)`
  text-decoration: none;
  color: inherit;
  grid-area: right-icon;
  justify-self: flex-end;
`;

export const Content = styled.div`
  display: flex;
  flex-grow: 1;
`;
